import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Axios from "axios";

import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import { withRouter } from "react-router";
import { districts, provinces } from "../../../../Components/Data/Province";
import { getCountries } from "../../../../Components/Data/Countries";
import { url } from "../../../../Config/Config";
import { connect } from "react-redux";
import { CustomLinearProgress } from "../../../../Components/CustomLinearProgress/CustomLinearProgress";
import { publicImageUrl } from "../../../../Config/publicImageUrl";
import { years } from "../../../../Components/Data/Session";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import FormLoader from "../../../../Components/FormLoader/FormLoader";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class AddStudent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      batchRef: createRef(),
      data: {
        currentSession: new Date().getFullYear().toString(),
        image: "",
        firstName: "",
        lastName: "",
        middleName: "",
        roll: "",
        bloodGroup: "",
        gender: "",
        dob_in_AD: "",
        dob_in_BS: "",
        nationality: "",
        email: "",
        admissionDate: "",
        studentClass: "",
        faculty: "",
        group: "",
        section: "",
        phoneNo: "",
        scholarshipType: "",
        address: {
          district: "",
          vdc: "",
          province: "",
          country: "",
          city: "",
        },
        father: {
          name: "",
          phoneNo: "",
          email: "",
        },
        mother: {
          name: "",
          phoneNo: "",
          email: "",
        },
        guardian: {
          name: "",
          phoneNo: "",
          relation: "",
          email: "",
        },
      },
      files: [],
      fileUrl: "",
      countries: [],
      classList: [],
      imageLoading: false,
      imageToDelete: "",
      deleteImage: false,
      imagePercentage: 0,
      error: {
        facultyError: "",
        groupError: "",
        sectionError: "",
        batchError: "",
        parentsError: "",
        imageError: "",
      },
      loading: false,
    };
  }

  componentDidMount() {
    this.getCountryData();
    this.getClasses();
    if (this.props.editStatus) {
      this.getEditData(this.props.studentId);
    }
  }
  getCountryData = async () => {
    let countries = await getCountries();
    this.setState({
      countries,
    });
  };

  getClasses = async () => {
    try {
      const response = await Axios.get(`${url}/api/schoolclass`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.classes.length !== 0) {
        this.setState({
          classList: response.data.classes,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getClasses();
      }
    }
  };

  getEditData = async (studentId) => {
    try {
      const response = await Axios.get(`${url}/api/students/${studentId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.student.length !== 0) {
        this.setState({
          imageToDelete: response.data.student.image,
          data: {
            ...this.state.data,
            currentSession: response.data.student.currentSession,
            firstName: response.data.student.firstName,
            middleName: response.data.student.middleName
              ? response.data.student.middleName
              : "",
            lastName: response.data.student.lastName,
            bloodGroup: response.data.student.bloodGroup,
            image: response.data.student.image,
            gender: response.data.student.gender,
            roll: response.data.student.roll,
            shift: response.data.student.shift,
            dob_in_AD: response.data.student.dob_in_AD,
            dob_in_BS: response.data.student.dob_in_BS,
            nationality: response.data.student.nationality,
            scholarshipType: response.data.student.scholarshipType,
            email: response.data.student.email,
            admissionDate: response.data.student.admissionDate,
            studentClass: response.data.student.studentClass,
            faculty: response.data.student.faculty
              ? response.data.student.faculty
              : "",
            group: response.data.student.group
              ? response.data.student.group
              : "",
            section: response.data.student.section,
            phoneNo: response.data.student.phoneNo,
            address: {
              district: response.data.student.address.district,
              vdc: response.data.student.address.vdc,
              province: response.data.student.address.province,
              country: response.data.student.address.country,
              city: response.data.student.address.city,
            },
            father: response.data.student.father
              ? {
                  name: response.data.student.father.name,
                  phoneNo: response.data.student.father.phoneNo,
                  email: response.data.student.father.email,
                }
              : { name: "", phoneNo: "", email: "" },
            mother: response.data.student.mother
              ? {
                  name: response.data.student.mother.name,
                  phoneNo: response.data.student.mother.phoneNo,
                  email: response.data.student.mother.email,
                }
              : { name: "", phoneNo: "", email: "" },
            guardian: response.data.student.guardian
              ? {
                  name: response.data.student.guardian.name,
                  phoneNo: response.data.student.guardian.phoneNo,
                  email: response.data.student.guardian.email,
                  relation: response.data.student.guardian.relation,
                }
              : { name: "", phoneNo: "", email: "", relation: "" },
          },
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getEditData(studentId);
      }
    }
  };

  handleStudentImage = async (e) => {
    let reader = new FileReader();
    let files = e.target.files[0];
    this.setState({
      files,
      imageLoading: true,
    });

    if (this.props.editStatus) {
      this.setState({
        deleteImage: true,
      });
    }

    reader.onload = () => {
      this.setState({ fileUrl: window.URL.createObjectURL(e.target.files[0]) });
    };

    reader.onprogress = (data) => {
      this.setState({
        imageLoading: false,
      });
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          imagePercentage: progress,
        });
      }
    };
    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleStudentImageProgress = () =>
    this.state.imagePercentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.imagePercentage}
          variant="determinate"
        />
        {this.state.imagePercentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.imagePercentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  handleAddress = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        address: {
          ...this.state.data.address,
          [e.target.name]: e.target.value,
        },
      },
    });
  };

  handleFatherChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        father: {
          ...this.state.data.father,
          [e.target.name]: e.target.value,
        },
      },
    });
  };
  handleMotherChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        mother: {
          ...this.state.data.mother,
          [e.target.name]: e.target.value,
        },
      },
    });
  };
  handleGuardianChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        guardian: {
          ...this.state.data.guardian,
          [e.target.name]: e.target.value,
        },
      },
    });
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        studentClass: e.target.value,
        faculty: "",
        group: "",
        section: "",
      },
    });
  };

  checkError = () => {
    let batchError = "";
    let imageError = "";
    let parentsError = "";
    let facultyError = "";
    let groupError = "";
    let sectionError = "";

    let fatherError = false;
    let motherError = false;
    let guardianError = false;
    let status = this.filterFaculty();

    if (status) {
      if (!this.state.data.faculty) {
        facultyError = "Please Enter Faculty";
      }
    }

    if (this.state.data.faculty) {
      if (!this.state.data.group) {
        groupError = "Please select group ";
      }
    }

    if (this.state.data.section === "") {
      sectionError = "Select one of the section";
    }

    if (
      this.state.data.father.name === "" &&
      this.state.data.father.phoneNo === "" &&
      this.state.data.father.email === ""
    ) {
      fatherError = true;
    }

    if (
      this.state.data.mother.name === "" &&
      this.state.data.mother.phoneNo === "" &&
      this.state.data.mother.email === ""
    ) {
      motherError = true;
    }

    if (
      this.state.data.guardian.name === "" &&
      this.state.data.guardian.phoneNo === "" &&
      this.state.data.guardian.email === "" &&
      this.state.data.guardian.relation === ""
    ) {
      guardianError = true;
    }

    if (fatherError && motherError && guardianError) {
      parentsError = "Enter at least one of the parents";
    }

    if (this.props.editStatus) {
      if (this.state.data.image === "") {
        imageError = "Please insert Image";
      }
    } else {
      if (this.state.fileUrl === "") {
        imageError = "Please insert Image";
      }
    }

    if (
      facultyError ||
      groupError ||
      sectionError ||
      batchError ||
      imageError ||
      parentsError
    ) {
      this.setState({
        error: {
          facultyError,
          groupError,
          sectionError,
          batchError,
          imageError,
          parentsError,
        },
      });
      return true;
    } else {
      this.setState({
        error: {
          facultyError: "",
          groupError: "",
          sectionError: "",
          batchError: "",
          imageError: "",
          parentsError: "",
        },
      });
      return false;
    }
  };

  filterFaculty = () => {
    const facultyFilter = this.state.classList
      .filter((filter) => filter.className === this.state.data.studentClass)
      .map((filter) => filter.faculty);
    let status = facultyFilter.map((filter) => {
      return filter === null || filter === undefined ? false : true;
    });
    if (status.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  uploadImage = async (files) => {
    const {
      data: { signedUrl, key },
    } = await Axios.post(`${url}/api/uploads`, {
      dir: "Students",
      contentType: files.type,
    });
    await Axios.put(signedUrl, this.state.files, {
      headers: {
        "content-type": files.type,
      },
    });
    await Axios.post(`${url}/api/uploads/public`, {
      fileName: key,
    });

    return key;
  };

  filterData = (data) => {
    let changedData = { ...data };
    if (!data.faculty) {
      delete changedData.faculty;
    }
    if (!data.group) {
      delete changedData.group;
    }
    if (!data.middleName) {
      delete changedData.middleName;
    }
    if (!data.father.name || !data.father.phoneNo || !data.father.email) {
      delete changedData.father;
    }
    if (!data.mother.name || !data.mother.phoneNo || !data.mother.email) {
      delete changedData.mother;
    }
    if (
      !data.guardian.name ||
      !data.guardian.phoneNo ||
      !data.guardian.email ||
      !data.guardian.relation
    ) {
      delete changedData.guardian;
    }

    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({
          loading: true,
        });
        if (this.props.studentId) {
          let changedData = this.filterData(this.state.data);
          let data;
          if (this.state.deleteImage === false) {
            data = { ...changedData };
          } else {
            data = { ...changedData };
            let imageKey = await this.uploadImage(this.state.files);
            data = { ...changedData, image: imageKey };
          }
          const editResponse = await Axios.put(
            `${url}/api/students/${this.props.studentId}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${this.props.adminToken}`,
              },
            }
          );
          if (this.state.deleteImage) {
            await Axios.post(
              `${url}/api/uploads/delete/`,
              {
                fileName: this.state.imageToDelete,
              },
              {
                headers: {
                  Authorization: `Bearer ${this.props.adminToken}`,
                },
              }
            );
          }
          if (editResponse.data.message === "student edited successfully") {
            this.props.history.push("/administration/students");
          }
        } else {
          let imageKey = await this.uploadImage(this.state.files);
          let changedData = this.filterData(this.state.data);
          let data;
          data = { ...changedData, image: imageKey };
          const response = await Axios.post(`${url}/api/students`, data, {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          });
          if (response.data.message === "student added successfully") {
            this.props.history.push("/administration/students");
          }
        }
      } catch (error) {
        this.setState({
          loading: false,
        });
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  compare = (a, b) => {
    const nameA = a;
    const nameB = b;

    let comparison = 0;
    if (nameA > nameB) {
      comparison = 1;
    } else if (nameA < nameB) {
      comparison = -1;
    }
    return comparison;
  };

  render() {
    const { classes } = this.props;
    districts.sort(this.compare);
    const classFilter = this.state.classList.map((data) => data.className);
    const facultyFilter = this.state.classList
      .filter((data) => data.className === this.state.data.studentClass)
      .map((data) => (data.faculty ? data.faculty : ""));
    const groupFilter = this.state.classList
      .filter(
        (data) =>
          data.className === this.state.data.studentClass &&
          data.faculty === this.state.data.faculty
      )
      .map((data) => (data.group ? data.group : ""));
    const sectionFilterClassOnly = this.state.classList
      .filter((data) => data.className === this.state.data.studentClass)
      .map((data) => data.section);
    const sectionFilter = this.state.classList
      .filter(
        (data) =>
          data.className === this.state.data.studentClass &&
          data.faculty === this.state.data.faculty &&
          data.group === this.state.data.group
      )
      .map((data) => data.section);
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          {this.props.studentId ? (
            <PageTitle title="Edit Student" />
          ) : (
            <PageTitle title="Add New Student" />
          )}
          <form onSubmit={this.handleSubmit}>
            <div>
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                Current Session
              </div>
              <TextField
                name="currentSession"
                select
                required
                label="Session/Batch"
                variant="outlined"
                margin="normal"
                placeholder="Session"
                className={classes.inputWithMargin}
                error={this.state.error.batchError ? true : false}
                helperText={this.state.error.batchError}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.currentSession}
                onChange={this.handleChange}
              >
                <option value="">Select Any Year</option>
                {years.map((year, index) => (
                  <option key={index} value={year}>
                    {year}
                  </option>
                ))}
              </TextField>
            </div>

            <div>
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                General Information
              </div>
              <div className={classes.imageStyle}>
                <div style={{ fontSize: 20 }}>Student Image</div>
                <div>
                  {this.state.fileUrl ? (
                    <img
                      src={`${this.state.fileUrl}`}
                      alt={this.state.data.firstName}
                      style={{ width: 100, height: 100 }}
                    />
                  ) : (
                    this.state.data.image && (
                      <img
                        src={`${publicImageUrl}/${this.state.data.image}`}
                        alt={this.state.data.firstName}
                        style={{ width: 100, height: 100 }}
                      />
                    )
                  )}
                </div>
                <div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handleStudentImage}
                  />
                  <div>
                    <div style={{ padding: 10 }}>
                      {this.handleStudentImageProgress()}
                    </div>
                    <div>
                      {this.state.imageLoading === true && <CircularProgress />}
                    </div>
                  </div>
                  <div style={{ color: "red", fontWeight: "bold" }}>
                    {this.state.error.imageError}
                  </div>
                </div>
              </div>

              <TextField
                name="firstName"
                type="text"
                required
                label="First Name"
                variant="outlined"
                margin="normal"
                placeholder="first name"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.firstName}
                onChange={this.handleChange}
              />

              <TextField
                name="middleName"
                type="text"
                label="Middle Name"
                variant="outlined"
                margin="normal"
                placeholder="Enter middle name"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.middleName}
                onChange={this.handleChange}
              />

              <TextField
                name="lastName"
                type="text"
                required
                label="last Name"
                variant="outlined"
                margin="normal"
                placeholder="Enter last name"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.lastName}
                onChange={this.handleChange}
              />

              <TextField
                name="gender"
                select
                required
                label="Gender"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{
                  native: true,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.gender}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Others">Others</option>
              </TextField>

              <TextField
                name="dob_in_AD"
                type="date"
                required
                label="Date of Birth(A.D)"
                variant="outlined"
                margin="normal"
                placeholder="Enter birth date in AD"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.dob_in_AD}
                onChange={this.handleChange}
              />

              <TextField
                name="dob_in_BS"
                type="date"
                required
                label="Date of Birth(B.S)"
                variant="outlined"
                margin="normal"
                placeholder="Enter birth date in BS"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.dob_in_BS}
                onChange={this.handleChange}
              />

              <TextField
                name="phoneNo"
                type="tel"
                required
                label="Mobile Number"
                variant="outlined"
                margin="normal"
                placeholder="Enter mobile number"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.phoneNo}
                onChange={this.handleChange}
              />

              <TextField
                name="email"
                type="email"
                label="Email"
                variant="outlined"
                margin="normal"
                placeholder="Enter email address"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.email}
                onChange={this.handleChange}
              />

              <TextField
                name="bloodGroup"
                select
                required
                label="Blood Group"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{
                  native: true,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.bloodGroup}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                <option value="O-">O-</option>
                <option value="O+">O+</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
              </TextField>
            </div>
            <div>
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                Admission Information
              </div>

              <TextField
                name="admissionDate"
                type="date"
                required
                label="Date of Admission"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.admissionDate}
                onChange={this.handleChange}
              />

              <TextField
                name="studentClass"
                select
                required
                label="Class"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.studentClass}
                onChange={this.handleChangeClass}
              >
                <option value="">Select Any One</option>
                {classFilter
                  .filter(
                    (value, index) => classFilter.indexOf(value) === index
                  )
                  .map((classData, index) => (
                    <option key={index} value={classData}>
                      {classData}
                    </option>
                  ))}
              </TextField>
              <TextField
                name="faculty"
                select
                label="Faculty"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                error={this.state.error.facultyError ? true : false}
                helperText={
                  this.state.error.facultyError
                    ? this.state.error.facultyError
                    : facultyFilter.length === 0
                    ? "Please Select Class to get faculties"
                    : "If there is no any faculty leave empty"
                }
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.faculty}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                {facultyFilter
                  .filter(
                    (value, index) => facultyFilter.indexOf(value) === index
                  )
                  .map((faculty, index) => (
                    <option key={index} value={faculty}>
                      {faculty}
                    </option>
                  ))}
              </TextField>
              <TextField
                name="group"
                select
                label="Group"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                error={this.state.error.groupError ? true : false}
                helperText={
                  this.state.error.groupError
                    ? this.state.error.groupError
                    : groupFilter.length === 0
                    ? "Please Select group to get groups"
                    : "If there is no any group leave empty"
                }
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.group}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                {groupFilter
                  .filter(
                    (value, index) => groupFilter.indexOf(value) === index
                  )
                  .map((group, index) => (
                    <option key={index} value={group}>
                      {group}
                    </option>
                  ))}
              </TextField>

              <TextField
                name="section"
                select
                required
                label="Section"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                error={this.state.error.sectionError ? true : false}
                helperText={
                  this.state.error.sectionError
                    ? this.state.error.sectionError
                    : sectionFilter.length === 0
                    ? "Please Select groups or class to get sections"
                    : null
                }
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.section}
                onChange={this.handleChange}
              >
                <option value="selected">Select Any One</option>
                {this.state.data.faculty && this.state.data.group
                  ? sectionFilter.length !== 0 &&
                    sectionFilter.map((section) =>
                      section.map((data, index) => (
                        <option key={index} value={data.name}>
                          {data.name}
                        </option>
                      ))
                    )
                  : sectionFilterClassOnly.length !== 0 &&
                    sectionFilterClassOnly.map((section) =>
                      section.map((data, index) => (
                        <option key={index} value={data.name}>
                          {data.name}
                        </option>
                      ))
                    )}
              </TextField>

              <TextField
                name="roll"
                type="text"
                required
                label="Roll Number"
                variant="outlined"
                margin="normal"
                placeholder="Enter roll number"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.roll}
                onChange={this.handleChange}
              />

              <TextField
                name="shift"
                select
                required
                label="Shift"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.shift}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                <option value="Morning Shift">Morining Shift</option>
                <option value="Day Shift">Day Shift</option>
                <option value="Night Shift">Night Shift</option>
              </TextField>
              <TextField
                name="scholarshipType"
                select
                required
                label="Scholarship Type"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.scholarshipType}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                <option value="Full Scholarship">Full Scholarship</option>
                <option value="Partial Scholarship">Partial Scholarship</option>
                <option value="Paid">Paid</option>
              </TextField>
            </div>

            <div>
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                Address Information
              </div>
              <TextField
                name="vdc"
                type="text"
                required
                label="VDC/Municipality"
                variant="outlined"
                margin="normal"
                placeholder="Enter VDC/Municipality"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.address.vdc}
                onChange={this.handleAddress}
              />

              <TextField
                name="city"
                type="text"
                required
                label="City"
                variant="outlined"
                margin="normal"
                placeholder="Enter city"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.address.city}
                onChange={this.handleAddress}
              />

              <TextField
                name="district"
                select
                required
                label="District"
                variant="outlined"
                margin="normal"
                placeholder="Enter district"
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.address.district}
                onChange={this.handleAddress}
              >
                <option value="">Select Any One</option>
                {districts.map((district, index) => (
                  <option key={index} value={district}>
                    {district}
                  </option>
                ))}
              </TextField>

              <TextField
                name="province"
                select
                required
                label="Province"
                variant="outlined"
                margin="normal"
                placeholder="Enter Province"
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.address.province}
                onChange={this.handleAddress}
              >
                <option value="">Select Any One</option>
                {provinces.map((province, index) => (
                  <option key={index} value={province}>
                    {province}
                  </option>
                ))}
              </TextField>

              <TextField
                name="nationality"
                type="nation"
                required
                label="Nationality"
                variant="outlined"
                margin="normal"
                placeholder="Enter nationality date in AD"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.nationality}
                onChange={this.handleChange}
              />

              <TextField
                name="country"
                select
                required
                label="Country"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{
                  native: true,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.address.country}
                onChange={this.handleAddress}
              >
                <option value="">Select Any One</option>
                {this.state.countries.map((country, index) => (
                  <option key={index} value={country.name}>
                    {country.name}
                  </option>
                ))}
              </TextField>
            </div>

            <div>
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                Parents Information
              </div>
              <div>
                Enter either father, mother , guardian details or every one's
                details
              </div>
              {this.state.error.parentsError && (
                <div style={{ color: "red", fontWeight: "bold" }}>
                  {this.state.error.parentsError}
                </div>
              )}
              <TextField
                name="name"
                type="text"
                label="Father's Name"
                variant="outlined"
                margin="normal"
                placeholder="Enter father's name"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.father.name}
                onChange={this.handleFatherChange}
              />
              <TextField
                name="phoneNo"
                type="tel"
                label="Father's Phone"
                variant="outlined"
                margin="normal"
                placeholder="Enter father's phone number"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.father.phoneNo}
                onChange={this.handleFatherChange}
              />
              <TextField
                name="email"
                type="email"
                label="Father's Email"
                variant="outlined"
                margin="normal"
                placeholder="Enter father's email"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.father.email}
                onChange={this.handleFatherChange}
              />
              <br />
              <TextField
                name="name"
                type="text"
                label="Mother's Name"
                variant="outlined"
                margin="normal"
                placeholder="Enter mother's name"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.mother.name}
                onChange={this.handleMotherChange}
              />
              <TextField
                name="phoneNo"
                type="tel"
                label="Mother's Phone"
                variant="outlined"
                margin="normal"
                placeholder="Enter mother's phone number"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.mother.phoneNo}
                onChange={this.handleMotherChange}
              />
              <TextField
                name="email"
                type="email"
                label="Mother's Email"
                variant="outlined"
                margin="normal"
                placeholder="Enter mother's email"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.mother.email}
                onChange={this.handleMotherChange}
              />
              <br />
              <TextField
                name="name"
                type="text"
                label="Guardian Name"
                variant="outlined"
                margin="normal"
                placeholder="Enter guardian's name"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.guardian.name}
                onChange={this.handleGuardianChange}
              />
              <TextField
                name="phoneNo"
                type="tel"
                label="Guardian Number"
                variant="outlined"
                margin="normal"
                placeholder="Enter guardian's number"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.guardian.phoneNo}
                onChange={this.handleGuardianChange}
              />
              <TextField
                name="relation"
                type="text"
                label="Guardian Relation"
                variant="outlined"
                margin="normal"
                placeholder="Relation with guardian"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.guardian.relation}
                onChange={this.handleGuardianChange}
              />

              <TextField
                name="email"
                type="email"
                label="Guardian Email"
                variant="outlined"
                margin="normal"
                placeholder="Enter email of guardian"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.guardian.email}
                onChange={this.handleGuardianChange}
              />
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                aria-label="Submit"
                type="submit"
                variant="outlined"
                color="primary"
                className={classes.buttonStyle}
              >
                {this.props.studentId ? "Update" : "Submit"}
              </Button>
              {this.state.loading && <FormLoader />}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddStudent)));
